import React from 'react';
import { useNavigate } from 'react-router-dom'; // 👈 dodane
import lifeImage from '../../images/nazycie.jpg';
import HeroSection from '../../components/HeroSection';
import OfertaCard from '../../components/OfertaCard';
import '../../style/ofertacard.css';

import FavoriteIcon from '@mui/icons-material/Favorite';

const NaZycie = () => {
  const navigate = useNavigate(); // 👈 dodane

  const handleCardClick = () => {
    navigate('/kontakt'); // 👈 przekierowanie do kontaktu
  };

  const offerings = [
    {
      label: 'Ochrona życia',
      icon: <FavoriteIcon />,
      color: '#FF6B6B',
      description: 'Zapewnia wsparcie finansowe dla rodziny w przypadku śmierci ubezpieczonego lub innych sytuacjach losowych, gwarantując stabilność w trudnych chwilach.'
    }
  ];

  return (
    <>
      <HeroSection
        image={lifeImage}
        text="Ubezpieczenia na życie – troszcz się o przyszłość bliskich"
      />

      <section style={{ maxWidth: '1100px', margin: '2rem auto', padding: '0 1rem' }}>
        <h2>Ubezpieczenia na życie</h2>
        <p>
          Ubezpieczenie na życie to forma troski o przyszłość Twoją i Twoich najbliższych. 
          W razie nieprzewidzianych zdarzeń zapewnia ochronę oraz finansowe wsparcie gwarantując stabilność w trudnych chwilach.
        </p>

        <div className="oferta-buttons" style={{ justifyContent: 'center', marginTop: '2rem', gap: '1.8rem' }}>
          {offerings.map(({ label, icon, color, description }) => (
            <OfertaCard
              key={label}
              label={label}
              icon={icon}
              color={color}
              description={description}
              onClick={handleCardClick} // 👈 przekazanie funkcji kliknięcia
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default NaZycie;
